/** @jsx jsx */
import { jsx } from '@emotion/core';
import { request, buttonStyles, outerWrap } from './requestDemoStyles';

import Button from '../../components/ui/Button';

export default function RequestDemo() {
  return (
    <div css={outerWrap}>
      <div css={request}>Request a demo</div>
      <Button styles={buttonStyles} to='/contact-us' text='Contact Us' />
    </div>
  );
}